/* ==========================================================================
   TEXTILE TOPIA — THEME JS
   ========================================================================== */

(function() {
  'use strict';

  /* ---------- Mobile Menu Toggle ---------- */
  var mobileToggle = document.querySelector('.mobile-menu-toggle');
  var nav = document.querySelector('.header-nav');

  if (mobileToggle && nav) {
    mobileToggle.addEventListener('click', function() {
      nav.classList.toggle('is-open');
      var expanded = nav.classList.contains('is-open');
      mobileToggle.setAttribute('aria-expanded', expanded);
    });

    // Mobile dropdown toggle
    document.querySelectorAll('.header-nav.is-open, .header-nav').forEach(function(navEl) {
      navEl.querySelectorAll('.has-dropdown > .header-nav-link').forEach(function(link) {
        link.addEventListener('click', function(e) {
          if (window.innerWidth <= 1024) {
            e.preventDefault();
            var parent = link.parentElement;
            parent.classList.toggle('is-open');
          }
        });
      });
    });
  }

  /* ---------- Variant Pills (Product Page) ---------- */
  var variantPills = document.querySelectorAll('.variant-pill');
  variantPills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      var group = pill.closest('.variant-pills');
      if (!group) return;
      group.querySelectorAll('.variant-pill').forEach(function(p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');

      // Update price if variant has price data
      var priceEl = document.querySelector('[data-variant-price]');
      var newPrice = pill.getAttribute('data-variant-price');
      if (priceEl && newPrice) {
        priceEl.textContent = newPrice;
      }

      // Update hidden variant ID input
      var variantInput = document.querySelector('[name="id"]');
      var variantId = pill.getAttribute('data-variant-id');
      if (variantInput && variantId) {
        variantInput.value = variantId;
      }
    });
  });

  /* ---------- Product Thumbnail Gallery ---------- */
  var thumbs = document.querySelectorAll('.product-thumb');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = thumb.querySelector('img').src;
      var mainImg = document.querySelector('.product-gallery-main img');
      if (mainImg) mainImg.src = src;
      document.querySelectorAll('.product-thumb').forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Quantity Selector ---------- */
  document.querySelectorAll('.quantity-selector').forEach(function(qs) {
    var input = qs.querySelector('input');
    var minus = qs.querySelector('[data-qty-minus]');
    var plus = qs.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function() {
      var v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function() {
      var v = parseInt(input.value) || 1;
      input.value = v + 1;
    });
  });

  /* ---------- Wholesale Inquiry Form Confirmation ---------- */
  document.querySelectorAll('form[data-wholesale-form]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      // Shopify's contact form handles submission. If needed, can show confirmation here.
      // Leaving default Shopify behavior intact.
    });
  });

  /* ---------- Smooth anchor links ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var id = a.getAttribute('href');
      if (id.length > 1) {
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

})();
